import React from 'react'
import { Box, SvgIconProps } from '@mui/material'
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer'
import SportsGolfIcon from '@mui/icons-material/SportsGolf'
import SportsCricketIcon from '@mui/icons-material/SportsCricket'
import SportsRugbyIcon from '@mui/icons-material/SportsRugby'
import SportsScoreIcon from '@mui/icons-material/SportsScore'
import SportsFootballIcon from '@mui/icons-material/SportsFootball'
import SportsTennisOutlinedIcon from '@mui/icons-material/SportsTennisOutlined'
import { LiaHorseHeadSolid } from 'react-icons/lia'

const HorseHeadIcon = LiaHorseHeadSolid as React.ElementType

function HorseRacingIcon({ sx, ...props }: SvgIconProps) {
  return (
    <Box component="span" sx={{ display: 'inline-flex', ...sx }}>
      <HorseHeadIcon size="1em" color="currentColor" />
    </Box>
  )
}

interface SportIconProps extends SvgIconProps {
  sportName?: string | null
}

function SportIcon({ sportName, ...props }: SportIconProps) {
  const normalizedSport = sportName?.toLowerCase()

  switch (normalizedSport) {
    case 'formula 1':
      return <SportsScoreIcon {...props} />
    case 'golf':
      return <SportsGolfIcon {...props} />
    case 'cricket':
      return <SportsCricketIcon {...props} />
    case 'rugby union':
    case 'rugby league':
      return <SportsRugbyIcon {...props} />
    case 'horse racing':
      return <HorseRacingIcon {...props} />
    case 'american football':
      return <SportsFootballIcon {...props} />
    case 'tennis':
      return <SportsTennisOutlinedIcon {...props} />
    case 'football':
    default:
      return <SportsSoccerIcon {...props} />
  }
}

export default SportIcon
